// extracted by mini-css-extract-plugin
export var back = "SectionDogSearchSuggestions-module--back--0860c";
export var buttonwrapper = "SectionDogSearchSuggestions-module--buttonwrapper--6f2fd";
export var dogfiltercontainer = "SectionDogSearchSuggestions-module--dogfiltercontainer--24bc7";
export var dogresultscontainer = "SectionDogSearchSuggestions-module--dogresultscontainer--1570f";
export var dogsearchsuggestionsinner = "SectionDogSearchSuggestions-module--dogsearchsuggestionsinner--230ed";
export var navbuttons = "SectionDogSearchSuggestions-module--navbuttons--c9c66";
export var next = "SectionDogSearchSuggestions-module--next--08080";
export var swiper = "SectionDogSearchSuggestions-module--swiper--754b6";
export var swiperwrapper = "SectionDogSearchSuggestions-module--swiperwrapper--ead0e";